// extracted by mini-css-extract-plugin
export default {"mainContainer":"SetBirthDay_mainContainer__Ynfee","creationContainer":"SetBirthDay_creationContainer__orvN8","dateTimePicker":"SetBirthDay_dateTimePicker__Agowk"};